import WizardContainer from './Containers/WizardContainer'

export default WizardContainer



// WEBPACK FOOTER //
// ./src/modules/Framework/Wizard/index.js